// import './update-quantity'

document.addEventListener('DOMContentLoaded', function () {
  const $menuToggle = document.querySelector('.site-header__menu-toggle')
  const $mainNavigation = document.querySelector('.site-header')

  $menuToggle.addEventListener('click', () => {
    console.log('clicked')
    $mainNavigation.classList.toggle('m-menu-active')
  })
})

document.addEventListener('scroll', function () {
  console.log('scrolling')
  // scrolled
  const scrolled = window.scrollY

  if (scrolled >= 1) {
    document.querySelector('html > body').classList.add('scrolled')
  } else {
    document.querySelector('html > body').classList.remove('scrolled')
  }
})
